
import {observable} from "mobx";
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {WPFormControlTypeEnum} from "./WPFormFactory";


export class InvoiceDetailColumn extends StoreBase{
    Type:InvoiceDetailColumnTypeEnum|string;
    Label:string;
    Format:InvoiceDetailColumnFormatEnum;
    protected LoadDefaultValues() {
        this.Type='';
        this.Label='';
        this.Format=InvoiceDetailColumnFormatEnum.string;
    }

}


export class InvoiceDetailControlOptions extends PDFControlBaseOptions{
    @observable
    Type:string;
    @StoreDataType(InvoiceDetailColumn)
    Columns:InvoiceDetailColumn[];
    ShowGrandTotal:boolean;
    GrandTotalLabel:string;
    RowSeparator:RowSeparatorEnum|string;
    EvenColor:string;
    EvenBackground:string;
    OddColor:string;
    OddBackground:string;
    BorderColor:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=WPFormControlTypeEnum.InvoiceDetail.toString();
        this.Columns=[];
        this.ShowGrandTotal=true;
        this.GrandTotalLabel='Total';
        this.RowSeparator=RowSeparatorEnum.Stripped.toString();

        this.OddColor='#000000';
        this.OddBackground='#FFFFFF';

        this.EvenBackground='#f9f9f9';
        this.EvenColor='#000000';
        this.BorderColor='#dfdfdf';
    }
}


export enum InvoiceDetailColumnTypeEnum{
    ProductName='name',
    Price='price'
}

export enum InvoiceDetailColumnFormatEnum{
    string='string',
    number='number'
}

export enum RowSeparatorEnum{
    None='none',
    Line='line',
    Stripped='stripped',
    LastRow='last'
}